import links from '../data/links';
const findLinkGroupByTitle = (title) => {
    return links.admin.find((linkGroup) => linkGroup.group_name === title);
};
export default findLinkGroupByTitle;
